/**
 * Interpreted effect records referenced by `EffectRef` in a call node's
 * `effects` array. `trace-ir` owns the lightweight reference; this package
 * owns the fuller payload each reference resolves to in `effects.json`.
 */
import { AmountSchema, HexAddressSchema, HexDataSchema, HexHashSchema, } from "@exploitlens/trace-ir";
import { z } from "zod";
export const NativeTransferEffectSchema = z.object({
    type: z.literal("native-transfer"),
    id: z.string().min(1),
    from: HexAddressSchema,
    to: HexAddressSchema,
    amountWei: AmountSchema,
});
export const TokenStandardSchema = z.enum(["ERC20", "ERC721", "ERC1155"]);
export const TokenTransferEffectSchema = z.object({
    type: z.literal("token-transfer"),
    id: z.string().min(1),
    token: HexAddressSchema,
    from: HexAddressSchema,
    to: HexAddressSchema,
    amount: AmountSchema,
    standard: TokenStandardSchema,
});
export const EventEffectSchema = z.object({
    type: z.literal("event"),
    id: z.string().min(1),
    address: HexAddressSchema,
    name: z.string().optional(),
    topics: z.array(HexHashSchema).max(4),
    data: HexDataSchema,
});
export const StorageWriteEffectSchema = z.object({
    type: z.literal("storage-write"),
    id: z.string().min(1),
    address: HexAddressSchema,
    slot: HexHashSchema,
    before: HexHashSchema,
    after: HexHashSchema,
});
export const EffectRecordSchema = z.discriminatedUnion("type", [
    NativeTransferEffectSchema,
    TokenTransferEffectSchema,
    EventEffectSchema,
    StorageWriteEffectSchema,
]);
/** The `effects.json` artifact written per side (vulnerable/patched) by EL-033. */
export const EffectsFileSchema = z.object({
    schemaVersion: z.literal("1.0"),
    caseId: z.string().min(1),
    side: z.enum(["vulnerable", "patched"]),
    effects: z.array(EffectRecordSchema),
});
//# sourceMappingURL=schema.js.map